export const ParticipantsFilters = {
    tags: 'tags',
    online: 'online',
    speakers: 'speakers',
    recommended: 'recommended'
} as const;

export type ParticipantsFilters = typeof ParticipantsFilters[keyof typeof ParticipantsFilters]